import {nextTick, ref} from 'vue'
import {createI18n} from 'vue-i18n'
import {i18n} from "store/global/locale";
import {getLocaleMessages} from "services/locale";

export const SUPPORT_LOCALES = ['en', 'de']
const loaded = [];
export const activeLocale = ref("en");

export const setupI18n = async (options = {
	legacy: false,
	locale: 'en', // set locale
	fallbackLocale: 'en',
	useScope: 'global',
	fallbackWarn: false,
	missingWarn: false
}) => {

	// Set Browser language as default
	try {
		navigator.languages.some((locale) => {
			if (SUPPORT_LOCALES.includes(locale)) {
				options.locale = locale;
				return options.locale === locale;
			}
		})
	} catch (e) {
		console.error("Could not fetch language", e)
	}

	i18n.value = createI18n(options)
	await setI18nLanguage(options.locale)

	await loadLocaleMessages("en");
	return i18n
}

export async function setI18nLanguage(locale) {

	await loadLocaleMessages(locale);
	i18n.value.global.locale = locale
	activeLocale.value = locale;
	/**
	 * NOTE:
	 * If you need to specify the language setting for headers, such as the `fetch` API, set it here.
	 * The following is an example for axios.
	 *
	 * axios.defaults.headers.common['Accept-Language'] = locale
	 */
	document.querySelector('html')?.setAttribute('lang', locale)
}

export async function loadLocaleMessages(locale) {

	if (loaded.includes(locale)) {
		return;
	}

	// load locale messages with dynamic import
	const messages = await getLocaleMessages(locale)

	// set locale and locale message
	i18n.value.global.setLocaleMessage(locale, messages.data)
	loaded.push(locale);

	return nextTick()
}
